/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('countryService', countryService)

    countryService.$inject = ['$http', 'CONFIG', 'messageService'];

    function countryService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/countries';
        var service = {
            getCountries: getCountries,
            getActiveCountries: getActiveCountries,
            getCountry: getCountry,
            saveCountry: saveCountry,
            thereNameCountry: thereNameCountry,
            thereIataCountry: thereIataCountry,
            updateCountry: updateCountry,
            deleteCountry: deleteCountry
        }

        return service;

        function getCountries(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getActiveCountries(active, detailed){
            return $http.get(urlBase + '/active?active=' + active + '&detailed=' + detailed)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.countries : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCountry(id){
            return $http.get(urlBase + "/" + id + "?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('countries')
                });
        }

        function saveCountry(country){
            return $http.post(urlBase, country)
                .then(function(response){
                    messageService.register('countries');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('countries')
                });
        }

        function thereNameCountry(name){
            return $http.get(urlBase + "/thereNameCountry/" + name, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function thereIataCountry(iataCode) {
            return $http.get(urlBase + "/thereIataCountry/" + iataCode, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function updateCountry(countryId, country){
            return $http.put(urlBase + "/" + countryId, country)
                .then(function(response){
                    messageService.registerUpdate('countries')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('countries')
                });
        }

        function deleteCountry(countryId){
            return $http.delete(urlBase + "/" + countryId)
                .then(function(response){
                    messageService.registerDelete('countries')
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('countries','air.country.associatedRegions')
                    }else{
                        messageService.registerDeleteError('countries')
                    }
                });
        }
    }
})();
